import { type FC, type PropsWithChildren, Suspense } from "react";
import { ThemeProvider } from "./theme-provider";

const RootProvider: FC<PropsWithChildren> = ({ children }) => {
	return (
		<ThemeProvider>
			<Suspense>{children}</Suspense>
		</ThemeProvider>
	);
};

export default RootProvider;
